var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"status-view-grid",class:_vm.statusClass},[_c('i',{class:_vm.statusIcon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }